import {Component} from '@angular/core';
import {RegisterCompanyStepBase} from '../register-company-step.base';

@Component({
    selector: 'app-register-company-welcome',
    templateUrl: './welcome-step.component.html',
    styleUrls: ['../../register-company.component.scss', './welcome-step.component.scss']
})
export class RegisterCompanyWelcomeStepComponent extends RegisterCompanyStepBase {
}
